import { render, staticRenderFns } from "./fencingdemo.vue?vue&type=template&id=ddb2ce0a&"
import script from "./fencingdemo.vue?vue&type=script&lang=js&"
export * from "./fencingdemo.vue?vue&type=script&lang=js&"
import style0 from "./fencingdemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports